var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-card--container",on:{"click":_vm.selectCategory}},[_c('v-icon',{attrs:{"color":_vm.getPrimaryColor,"size":"24"}},[_vm._v(_vm._s(_vm.icon))]),_c('h4',[_vm._v(_vm._s(_vm.$t(_vm.title)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }